import { Box, Chip } from "@mui/material";

import { GreyPallet } from "../../../config/styles";

type ChipMainProps = {
  options: { name: string; value: string | number }[];
  value: string | number | string[] | number[];
  onChange: (value: string | number) => void;
  disabled?: boolean;
  multiple?: boolean;
};

export default function ChipMain({ options, value, onChange, disabled, multiple }: ChipMainProps) {
  return (
    <>
      {options.map((item) => (
        <Box key={item.value}>
          <Chip
            disabled={disabled}
            label={item.name}
            variant={"outlined"}
            sx={{
              opacity: disabled ? 0.6 : 1,
              borderWidth: 3,
              color:
                ((multiple ? (value as any[])?.includes(item.value) : value === item.value)
                  ? "white"
                  : GreyPallet.Black) + " !important",
              borderColor:
                ((multiple ? (value as any[])?.includes(item.value) : value === item.value)
                  ? GreyPallet.Black
                  : GreyPallet.LightGhost) + " !important",
              backgroundColor:
                ((multiple ? (value as any[])?.includes(item.value) : value === item.value)
                  ? GreyPallet.Black
                  : "transparent") + " !important",
            }}
            onClick={() => onChange(item.value)}
          />
        </Box>
      ))}
    </>
  );
}
